import axios from "axios"
import store from '../../index'
import {registerPlugin} from "@capacitor/core";
import {Device} from "@capacitor/device";
import {Client} from '@stomp/stompjs';

const BackgroundGeolocation = registerPlugin("BackgroundGeolocation");
const authenticate = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        login: async function (context, payload) {
            let response = await axios.post("/auth", payload);
            if (response.status === 200) {
                const client = new Client({
                    brokerURL: 'wss://rabbit.norl.ir:15673/ws',
                    connectHeaders: {
                        login: 'user_tracking',
                        passcode: 'FP2QrRhz!6i92rz',
                    },
                    reconnectDelay: 5000,
                    heartbeatIncoming: 4000,
                    heartbeatOutgoing: 4000,

                });
                client.onConnect = async function (frame) {
                    if (frame.command === 'CONNECTED') {
                        if ((await Device.getInfo()).platform !== "web") {
                            let last_location;
                            await BackgroundGeolocation.addWatcher(
                                {
                                    requestPermissions: true,
                                    stale: false,
                                },
                                async function (location) {
                                    last_location = location || undefined;
                                    const locationData = {
                                        latitude: last_location.latitude,
                                        longitude: last_location.longitude,
                                        accuracy: last_location.accuracy,
                                        speed: last_location.speed,
                                        userName: payload.username,
                                        uuid: await Device.getId(),
                                    }
                                    client.publish({
                                        destination: '/exchange/user_tracking',
                                        body: JSON.stringify(locationData)
                                    });
                                }
                            ).then(function (id) {
                                store.state.watcherId = id
                            });
                        }
                    }
                };
                client.onStompError = async function (err) {
                    console.log(err)
                };
                client.activate();
                store.state.rabbitmqClient = client

                window.localStorage.setItem("access_token", response.data.access_token);
                window.localStorage.setItem("userName", response.data.auth);
                window.localStorage.setItem("roles", JSON.stringify(response.data.roles.toLowerCase().split(",")));
                window.localStorage.setItem("firstName", response.data.first_name);
                window.localStorage.setItem("lastName", response.data.last_name);
                window.localStorage.setItem("userMobile", response.data.mobile_no.replace("+98", "0"));
                window.localStorage.setItem("internalUserMobile", response.data.internal_mobile);
                window.localStorage.setItem("internalUserMobile2", response.data.internal_mobile2);
                window.localStorage.setItem("userID", response.data.userId);
                window.localStorage.setItem("avayaExt", response.data.avayaExt);
                window.localStorage.setItem("postfixPhone1", response.data.postfix_phone1);
                window.localStorage.setItem("postfixPhone2", response.data.postfix_phone2);
                window.localStorage.setItem("postfixPhone3", response.data.postfix_phone3);
                window.localStorage.setItem("storeAccessList", response.data.storeList);
                window.localStorage.setItem("issueOrderRemittanceStoreList", response.data.issueOrderRemittanceStoreList);
                window.localStorage.setItem("phone", response.data.phone);
                store.state.accessToken = response.data.access_token;
                store.state.userName = response.data.auth;
                store.state.roles = response.data.roles.toLowerCase().split(",");
                store.state.isLogged = true;
                store.state.firstName = response.data.first_name;
                store.state.lastName = response.data.last_name;
                store.state.userMobile = response.data.mobile_no.replace("+98", "0");
                store.state.internalUserMobile = response.data.internal_mobile;
                store.state.internalUserMobile2 = response.data.internal_mobile2;
                store.state.postfixPhone1 = response.data.postfix_phone1;
                store.state.postfixPhone2 = response.data.postfix_phone2;
                store.state.postfixPhone3 = response.data.postfix_phone3;
                store.state.avayaExt = response.data.avayaExt
                store.state.storeAccessList = response.data.storeList.split(",");
                store.state.issueOrderRemittanceStoreList = response.data.issueOrderRemittanceStoreList.split(",");
                store.state.phone = response.data.phone
                store.state.userId = response.data.userId
                axios.defaults.headers.Authorization = store.state.jwtType + store.state.accessToken;
                return response;
            } else if (response.data.error) {
                throw new Error("Something is wrong");
            }
        },
        async logout() {
            store.state.isLogged = false;
            localStorage.clear();
            store.state.rabbitmqClient.forceDisconnect()
            if ((await Device.getInfo()).platform !== "web") {
                await BackgroundGeolocation.removeWatcher({
                    id: store.state.watcherId
                });
            }
        },
        async changePassword(context, payload) {
            let response = await axios.post(`/change_password/${store.state.userName}`, payload);
            return response
        },
        async addLocation(context, payload) {
            await axios.post(`/add_location`, payload);
        },
        guess_location(callback, timeout) {
            let last_location;
            BackgroundGeolocation.addWatcher(
                {
                    requestPermissions: true,
                    stale: true
                },
                function (location) {
                    last_location = location || undefined;
                }
            ).then(function (id) {
                setTimeout(function () {
                    callback(last_location);
                    BackgroundGeolocation.removeWatcher({id});
                }, timeout);
            });
        }
    },
    getters: {}
}

export default authenticate;
